const ENABLE_LOGGING: boolean = process.env.ENABLE_LOGGING === 'true' || false

export function log(...args: any) {
  if (ENABLE_LOGGING) {
    console.log(...args)
  }
}
